import React from "react";
import warning from "../../../assets/warning.svg";

const RemoveConfirmation = ({ onCancel, onConfirm, kpi }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-80 w-screen h-screen flex justify-center items-center font-inter">
      <div className="bg-white rounded-[10px] max-w-[400px] w-full flex flex-col justify-center items-center gap-4 py-[45px]">
        <img src={warning} alt="" className="" />
        <h1 className="text-[1.375rem]">Please Confirm</h1>
        <div className="">
          <p className="font-medium max-w-[302px] text-base text-center leading-5 pt-1">
            If you have previously added any data,
          </p>
          <p className="font-medium max-w-[302px] text-base text-center leading-5">
            it will be lost.
          </p>
        </div>
        <div className="flex items-center justify-between gap-5 mt-6">
          <button
            className="border border-[#D9D9D9] font-normal text-base rounded-[10px]"
            onClick={() => onCancel(false)}
          >
            No
          </button>
          <button
            className="bg-[#55C880] px-6 font-normal text-base rounded-[10px] text-white"
            onClick={() => onConfirm(kpi._id)}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveConfirmation;
